import { AuthViewModel } from "../../AuthWrapper2/viewmodels/AuthViewModel.js";
import { useDownloadsApiServiceContext } from "../../../contexts/DownloadsApiServiceContext.js";
import { useEffect } from "react";
import { useSingleton } from "mvc-kit/react";
//#region src/modules/AppWrapper2/components/DownloadsAuthSync.tsx
/**
* Bridges the session auth token into DownloadsApiServiceContext, which
* threads it into the downloads-api request headers so PDF/report downloads
* authenticate as the current user.
*
* Mirrors DownloadsRegionSync: AuthViewModel is a plain class and cannot
* reach a React context directly. Reading `authVM.state.authToken` (rather
* than subscribing to specific auth events) means every path that changes
* the token - login, profile switch, cross-tab sync, god-mode impersonation -
* flows through the same effect.
*
* Session-expiry paths (401 interceptor, failed validateSession/refreshIdentity,
* UserDeactivated) clear AuthViewModel's token and identityInfo in the same
* `set()`, which makes AuthWrapper2 unmount this component (and the rest of
* the app shell) in that same commit to show <AuthGate/> - the effect body
* never runs again to observe the cleared token. The cleanup function covers
* that: unmounting for any reason clears the downloads token too, so it can't
* be left holding a session token that's no longer valid.
*/
function DownloadsAuthSync() {
	const authVM = useSingleton(AuthViewModel);
	const { setAuthToken } = useDownloadsApiServiceContext({ ctxRequired: false });
	useEffect(() => {
		setAuthToken?.(authVM.state.authToken);
	}, [authVM.state.authToken, setAuthToken]);
	useEffect(() => {
		return () => setAuthToken?.("");
	}, [setAuthToken]);
	return null;
}
//#endregion
export { DownloadsAuthSync };

//# sourceMappingURL=DownloadsAuthSync.js.map